export const isJuSiHong = (subdomain?: string) => {
    return subdomain === 'Joyce' || subdomain === 'cxqi';
};

export const LoginStatusCode = {
    /** 单个租户 */
    Single: 100,
    /** 多个租户 */
    Multi: 101,
    /** 二次验证开启 且 手机号有效 */
    Verify: 102,
    /** 二次验证开启 但 手机号无效 */
    VerifyFail: 103,
};
